import {Directive, Input, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({
  // tslint:disable: directive-selector
  selector: 'img[default]',
  host: {
    '(error)': 'updateUrl()',
    '[src]': 'src',
    '[attr.usedefault]': 'usedefault'
  }
})

export class ImagePreloadDirective {
  @Input() src: string;
  @Input() default: string;
  @Input() usedefault: boolean;


  updateUrl() {
    this.src = this.default || '/assets/imgs/commons/image-default.png';
    this.usedefault = true;
  }
}

@NgModule({
  imports: [ CommonModule ],
  declarations: [ ImagePreloadDirective ],
  exports: [ ImagePreloadDirective ]
})
export class ImagePreloadDirectiveModule { }
